module.exports = __webpack_public_path__ + "static/media/locals.04caec66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/locals.jpg
// module id = 295
// module chunks = 0